export default "__VITE_ASSET__nyQagPN8__"